/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileUrl } from '../../models/file-url';

export interface ApiFileFileIdDelete$Params {
  file_id: number;
}

export function apiFileFileIdDelete(http: HttpClient, rootUrl: string, params: ApiFileFileIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
  const rb = new RequestBuilder(rootUrl, apiFileFileIdDelete.PATH, 'delete');
  if (params) {
    rb.path('file_id', params.file_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileUrl>;
    })
  );
}

apiFileFileIdDelete.PATH = '/api/file/{file_id}';
